import type { CaptureTargetView } from './CaptureViewTarget';

// ビュー単体・ビューモデル全体のキャプチャ結果。
// MCPブリッジの get_view_model_image / get_view_image の成功 result としてそのまま送出するため、
// フィールドはワイヤ仕様（decisions.md §2）に一致させる。
export type CaptureImageResult = {
  completedAt: string;
  image: { mimeType: 'image/png'; dataBase64: string };
  width: number;
  height: number;
  // 現存ビュー一覧。get_view_model_image の成功時のみ同梱する任意フィールド
  // （viewContents 未取得時は空配列で「ビューが無い」と誤認させないよう省略する）
  views?: CaptureTargetView[];
};

// ブラウザ送信前サイズチェックの上限（base64 文字列長）。
// MCP サーバ側の WebSocket 受信上限（16MiB）を超えると接続ごと切断されペアリングが死ぬため、
// その手前の 10MiB 相当で送信せず payload_too_large として綺麗に失敗させる。
export const CAPTURE_IMAGE_MAX_BASE64_LENGTH = 10 * 1024 * 1024;

const PNG_DATA_URL_PREFIX = 'data:image/png;base64,';

// canvas.toDataURL('image/png') が返す data URL から素の base64 部分を取り出す
export function pngDataUrlToBase64(dataUrl: string): string {
  if (!dataUrl.startsWith(PNG_DATA_URL_PREFIX)) {
    throw new Error(`unexpected data URL format: ${dataUrl.slice(0, PNG_DATA_URL_PREFIX.length)}`);
  }
  return dataUrl.slice(PNG_DATA_URL_PREFIX.length);
}
